import { render, staticRenderFns } from "./TechnicalInformation.vue?vue&type=template&id=c10eb65e&"
import script from "./TechnicalInformation.vue?vue&type=script&lang=js&"
export * from "./TechnicalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports